module.exports = __webpack_public_path__ + "assets/9019a2d52b7fe07c80fd442d9095d9ad.png";